import { aludraApi } from 'api/axios'
import { mdl14Urls } from './mdl14.urls'

export const calculateCalculator = async payload => {
  return aludraApi.post(mdl14Urls.calculatorURL, payload)
}

export const validateAmountOnCommercialCredit = async payload => {
  return aludraApi.post(mdl14Urls.ValidateCommercialCreditURL, payload)
}
